import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type CurrentSelectedSidebarCellState = string;
type ShowStickySidebarState = boolean | string;

const initialCurrentSelectedSidebarCellState: CurrentSelectedSidebarCellState = "";
const initialShowStickySidebarState = "" as ShowStickySidebarState;

const currentSelectedSidebarCellSlice = createSlice({
  name: "currentSelectedSidebarCell",
  initialState: initialCurrentSelectedSidebarCellState,
  reducers: {
    setSidebarSelectedCell: (
      _state: CurrentSelectedSidebarCellState,
      action: PayloadAction<CurrentSelectedSidebarCellState>,
    ) => action.payload,
  },
});

const showStickySidebarSlice = createSlice({
  name: "showStickySidebar",
  initialState: initialShowStickySidebarState,
  reducers: {
    setShowStickySidebar: (_state: ShowStickySidebarState, action: PayloadAction<ShowStickySidebarState>) =>
      action.payload,
  },
});

export const { setSidebarSelectedCell } = currentSelectedSidebarCellSlice.actions;
export const { setShowStickySidebar } = showStickySidebarSlice.actions;

export const currentSelectedSidebarCell = currentSelectedSidebarCellSlice.reducer;
export const showStickySidebar = showStickySidebarSlice.reducer;

export default {
  currentSelectedSidebarCell: currentSelectedSidebarCellSlice.reducer,
  showStickySidebar: showStickySidebarSlice.reducer,
};
